import { IStep1Form } from './Step1/formInterface';
import { ILocationItem, IStep2Form } from './Step2/formInterfaces';
import { IStep3Form } from './Step3/formInterface';
import { IStep4Form } from './Step4/formInterface';
import { IStep5Form } from './Step5/formInterfaces';

// Factory + derived-constant pair per step — see the header of
// components/JobStepper/staticValues.ts for why (D-24094 §13). StepperPanel must
// reset through the factories or `putSteps` never re-fires after `dropStepper()`.
// `staticValuesForStep2.locations` shared the `itemLocation` singleton, so the
// factory rebuilds that too.

const makeItemLocation = (): ILocationItem => ({
  isShowState: true,
  country: 'US',
  state: null,
  province: null,
  address1: null,
  address2: null,
  city: null,
  zip: null
});

export const itemLocation: ILocationItem = makeItemLocation();

export const makeStaticValuesForStep1 = (): IStep1Form => ({
  jobTitle: null,
  companyName: null,
  employmentTypeId: 0,
  industrySectorId: 0,
  supplierId: null,
  supplierTitle: null,
});
export const staticValuesForStep1: IStep1Form = makeStaticValuesForStep1();

export const makeStaticValuesForStep2 = (): IStep2Form => ({
  salaryMax: null,
  salaryMin: null,
  salaryUnitId: 5,
  salaryExact: null,
  locations: [makeItemLocation()],
  noneLocation: false,
  salaryUnitRadio: 2,
});
export const staticValuesForStep2: IStep2Form = makeStaticValuesForStep2();

export const makeStaticValuesForStep3 = (): IStep3Form => ({
  shortDescription: null,
  jobDescription: ''
});
export const staticValuesForStep3: IStep3Form = makeStaticValuesForStep3();

export const makeStaticValuesForStep4 = (): IStep4Form => ({
  uploadedLogoPath: null
});
export const staticValuesForStep4: IStep4Form = makeStaticValuesForStep4();

export const makeStaticValuesForStep5 = (): IStep5Form => ({
  email: null,
  applicationEmail: '',
  contactLastName: null,
  contactFirstName: null,
  applicationUrl: null,
  showEmails: true,
  applicationUrlEnabled: false,
  tempAdditionalEmails: [
    {
      email: null
    }
  ]
});
export const staticValuesForStep5: IStep5Form = makeStaticValuesForStep5();
